module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Specialties")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.item.specialties))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Capabilities")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.item.capabilities))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Capabilities Statements")])], 1), _vm._v(" "), _c('v-card-action', [(_vm.props.item.capabilitiesstatement) ? _c('v-btn', {
    attrs: {
      "target": "_blank",
      "href": _vm.props.item.capabilitiesstatement,
      "round": "",
      "color": "red lighten-1",
      "dark": ""
    }
  }, [_vm._v("View PDF")]) : _vm._e(), _vm._v(" "), (!_vm.props.item.capabilitiesstatement) ? _c('v-card-text', [_vm._v("Not Available")]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-853d3f54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/Request/company/other_info.vue
// module id = 1235
// module chunks = 3 4